"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.baseTabPropTypes = void 0;
exports.default = Tab;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _reactBootstrap = require("react-bootstrap");
var _jsxRuntime = require("react/jsx-runtime");
function Tab({
  tab: {
    label,
    prefix,
    suffix,
    id: tabId,
    path,
    disabled,
    color,
    tooltip
  },
  active,
  onClick,
  fullWidth,
  alignTabLabel,
  minTabWidth,
  maxTabWidth,
  Link = _reactRouterDom.Link
}) {
  const El = path ? Link : 'button';
  const tabProps = path ? {
    to: path
  } : {};
  const content = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    id: `tab-${tabId}`,
    className: ['ccl-l-tabs__tab', fullWidth ? 'ccl-l-tabs__tab--full-width' : '', active ? 'ccl-l-tabs__tab--is-active' : '', disabled ? 'ccl-l-tabs__tab--disabled' : ''].join(' '),
    style: {
      ...(minTabWidth ? {
        minWidth: `${minTabWidth}px`
      } : {}),
      ...(maxTabWidth ? {
        maxWidth: `${maxTabWidth}px`
      } : {})
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(El, {
      onClick: onClick,
      tabIndex: disabled ? -1 : 1,
      "data-analytics": tabId,
      className: ['ccl-l-tabs__tab__button', color ? `ccl-l-tabs__tab__button--color--${color}` : '', alignTabLabel ? `ccl-l-tabs__tab__button--align--${alignTabLabel}` : ''].join(' '),
      ...tabProps,
      children: [prefix && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "ccl-l-tabs__tab__button__prefix",
        children: prefix
      }), label && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "ccl-l-tabs__tab__button__label",
        children: label
      }), suffix && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "ccl-l-tabs__tab__button__suffix",
        children: suffix
      })]
    })
  }, tabId);
  return tooltip ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactBootstrap.OverlayTrigger, {
    overlay: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactBootstrap.Tooltip, {
      id: `tab-tooltip-${tabId}`,
      children: tooltip
    }),
    children: content
  }) : content;
}
const baseTabPropTypes = exports.baseTabPropTypes = {
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  prefix: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  suffix: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  id: _propTypes.default.string,
  path: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  color: _propTypes.default.oneOf([undefined, 'error', 'success', 'warning']),
  tooltip: _propTypes.default.string
};